module.exports = __webpack_public_path__ + "img/secondary_10x2_z16.3dea33f2.svg";